<template>
  <div class="content w-full">
    <TopNavbar />
    <div class="page-content">
      <DynamicVisibility  ref="dynamicVisibility">
        <template #primary>
          <AppOverviewComponent @toggle-visibility="toggleVisibility" />
        </template>

        <template #secondary>
					<ProfileComponent />
        </template>
      </DynamicVisibility>
    </div>
  </div>
</template>

<script>
import TopNavbar from '@/components/user/layout/TopNavbar.vue';
import ProfileComponent from '@/components/user/viewComponent/profile/ProfileComponent.vue';
import AppOverviewComponent from "@/components/user/viewComponent/app/AppOverviewComponent.vue";
import DynamicVisibility from "@/components/custom/visibility/DynamicVisibility.vue";

export default {
	name: 'ListsViewComponent',
	components: {
		TopNavbar,
		ProfileComponent,
		AppOverviewComponent,
		DynamicVisibility,
	},
  methods: {
    toggleVisibility(visible) {
      this.$refs.dynamicVisibility.toggle(visible);
    },
  },
};
</script>